<template>
  <div class="page-tarifs">
    <landing-header />

    <main class="py-32 bg-white">
      <section class="text-center max-w-7xl mx-auto px-4 mb-16">
        <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight">
          Investissez dans votre <span class="gradient-text">réussite</span>
        </h1>
        <p class="text-xl text-gray-600">
          Des outils complets, aucune fonctionnalité essentielle bridée. 
          Choisissez l'offre qui correspond à votre structure.
        </p>
      </section>

      <section class="max-w-7xl mx-auto px-4 mb-20">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          
          <div class="tier-card">
            <div class="tier-header">
              <span class="tier-name">Indépendant</span>

              <div class="tier-price my-2">
                  <span class="tier-old-price">45€</span>
                  <span class="text-3xl font-black">30€</span><span class="unit">/mois HT</span>
              </div>

              <p class="tier-desc">L'arsenal complet pour l'artisan qui veut une structure de grand groupe.</p>

              <a href="/register">
                  <button class="btn-tier-outline">Démarrer mon essai</button>
              </a>
          </div>
            
            <div class="tier-content">
              <p class="content-title">Inclus dans votre abonnement :</p>
              
              <div class="feature-grid-mini">
                <div class="f-item"><strong>Gestion Opérationnelle :</strong> Suivi interventions, planning intelligent, calcul des temps de trajet (départ/retour), gestion sites & clients.</div>
                <div class="f-item"><strong>App Mobile Métier :</strong> Mode déconnecté, rapports terrain, signatures clients, accès complet base clients/appareils.</div>
                <div class="f-item"><strong>CERFA & Conformité :</strong> Génération auto, pré-remplissage terrain, lien bouteilles/détecteurs, archivage légal complet.</div>
                <div class="f-item"><strong>Base de Connaissance :</strong> 72 000 modèles d'appareils accessibles en 1 clic.</div>
                <div class="f-item"><strong>Stock & Fluides :</strong> Gestion stock camion, traçabilité gaz (utilisé/récupéré), suivi bouteilles & étalonnage détecteurs.</div>
                <div class="f-item"><strong>Relation Client :</strong> Gestion des contrats d'entretien, SMS de rappel auto, messages post-visite, historique centralisé.</div>
                <div class="f-item"><strong>Pilotage & Intégration :</strong> Stats d'activité, exports Excel (stock/fluides), connexion logiciel de facturation.</div>
              </div>
              <div class="tier-footer-note">Une solution métier sans compromis.</div>
            </div>
          </div>

          <div class="tier-card featured">
            <div class="popular-ribbon">Recommandé pour la croissance</div>
            <div class="tier-header">
              <span class="tier-name text-orange-600">Entreprise</span>
              <div class="tier-price my-2">
                  <span class="tier-old-price">70€</span>
                  <span class="text-3xl font-black">55€</span><span class="unit">/tech/mois HT</span>
              </div>
              <p class="tier-desc">Pour piloter vos équipes, vos stocks et votre image de marque avec précision.</p>
              <a href="/contact"><button class="btn-tier-primary">Demander une démo</button></a>
            </div>
            
            <div class="tier-content">
              <p class="content-title">Tout l'Indépendant, PLUS :</p>
              
              <div class="feature-grid-mini">
                <div class="f-item"><strong>Pilotage d'Équipe :</strong> Planning multi-techniciens, affectation avancée, suivi de charge, stats de performance par collaborateur.</div>
                <div class="f-item"><strong>Logistique Avancée :</strong> Gestion multi-stocks (Camions + Entrepôt + Chantiers), historique complet des mouvements.</div>
                <div class="f-item"><strong>Portail Client Premium :</strong> Espace sécurisé 24/7 pour vos clients (Historique, Documents, CERFA, Contrats).</div>
                <div class="f-item"><strong>Marketing Automatisé :</strong> Collecte d'avis Google auto après intervention, scénarios de fidélisation personnalisés.</div>
                <div class="f-item"><strong>Reporting Stratégique :</strong> Analyses avancées des temps, exports filtrés multi-critères, aide à la décision.</div>
                <div class="f-item"><strong>Audit & Sécurité :</strong> Traçabilité fluide renforcée, vision consolidée pour contrôles réglementaires.</div>
              </div>
              <div class="tier-footer-note text-orange-700">L'outil ultime pour structurer et faire grandir votre entreprise.</div>
            </div>
          </div>

        </div>
      </section>

      <section class="max-w-5xl mx-auto px-4 py-16 bg-gray-50 rounded-[3rem] mb-20 border border-gray-100">
        <h2 class="text-3xl font-bold text-center mb-12">Un investissement immédiatement rentable</h2>
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 text-center">
          <div class="benefit-v">
            <i class="fa-solid fa-keyboard"></i>
            <span>Zéro double saisie</span>
          </div>
          <div class="benefit-v">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>Zéro risque légal</span>
          </div>
          <div class="benefit-v">
            <i class="fa-solid fa-chart-line"></i>
            <span>+ de visibilité</span>
          </div>
          <div class="benefit-v">
            <i class="fa-solid fa-screwdriver-wrench"></i>
            <span>+ d'interventions</span>
          </div>
          <div class="benefit-v">
            <i class="fa-solid fa-medal"></i>
            <span>Image Pro</span>
          </div>
        </div>
      </section>

      <section class="text-center px-4">
        <p class="text-gray-500 font-bold mb-4 italic">Termoflow remplace plusieurs outils par une seule plateforme métier.</p>
        <h3 class="text-2xl font-bold mb-8">Besoin d’un cas spécifique ou d'un conseil ?</h3>
        <a href="/contact" class="btn-primary-large">Parler à un conseiller Termoflow</a>
      </section>
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue';
import LandingFooter from './LandingFooter.vue';
export default {
  name: 'LandingTarifs',
    components: {
        LandingHeader,
        LandingFooter
    }
};
</script>

<style scoped>
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* CARDS */
.tier-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
}
.tier-card.featured {
  border: 2px solid #f97316;
  box-shadow: 0 25px 50px -12px rgba(249, 115, 22, 0.15);
  position: relative;
}
.popular-ribbon {
  position: absolute;
  top: 4.5rem;
  right: -4rem;
  background: #f97316;
  color: white;
  transform: rotate(45deg);
  padding: 0.5rem 4rem;
  font-size: 0.7rem;
  font-weight: 900;
  text-transform: uppercase;
}

.tier-header { padding: 3rem 3rem 2rem; text-align: center; border-bottom: 1px solid #f3f4f6; }
.tier-name { font-size: 1.25rem; font-weight: 900; text-transform: uppercase; letter-spacing: 0.1em; color: #4b5563; }
.tier-price {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 0.75rem;
}

.tier-old-price {
  position: relative;
  font-size: 1.2rem;
  font-weight: 800;
  color: #f97316;
  opacity: 0.8;
  padding: 0.25rem 0.6rem;
  border-radius: 9999px;
  background: rgba(249, 115, 22, 0.08);
  letter-spacing: 0;
}

.tier-old-price::after {
  content: "";
  position: absolute;
  left: -5%;
  top: 50%;
  width: 110%;
  height: 2px;
  background: linear-gradient(to right, #f97316, #ef4444);
  transform: rotate(-8deg);
}
.tier-price .unit { font-size: 1rem; color: #9ca3af; letter-spacing: 0; font-weight: 600; }
.tier-desc { color: #6b7280; font-weight: 500; font-size: 0.95rem; margin-bottom: 2rem; }

/* CONTENT */
.tier-content { padding: 2rem 2.5rem 3rem; background: #fafafa; flex: 1; }
.content-title { font-weight: 800; color: #111827; margin-bottom: 1.5rem; font-size: 1rem; }

.feature-grid-mini { display: flex; flex-direction: column; gap: 1.25rem; }
.f-item { font-size: 0.88rem; line-height: 1.5; color: #4b5563; position: relative; padding-left: 1.5rem; }
.f-item::before { 
    content: "→"; 
    position: absolute; 
    left: 0; 
    color: #f97316; 
    font-weight: 900; 
}
.f-item strong { color: #111827; font-weight: 700; }

.tier-footer-note { margin-top: 2rem; font-weight: 800; font-size: 0.9rem; border-top: 1px dashed #d1d5db; padding-top: 1.5rem; }

/* BUTTONS */
.btn-tier-outline { width: 100%; border: 2px solid #e5e7eb; padding: 1rem; border-radius: 0.75rem; font-weight: 800; color: #111827; transition: all 0.2s; }
.btn-tier-outline:hover { background: #f9fafb; border-color: #d1d5db; }
.btn-tier-primary { width: 100%; background: #f97316; padding: 1rem; border-radius: 0.75rem; font-weight: 800; color: white; border: none; box-shadow: 0 4px 14px 0 rgba(249, 115, 22, 0.39); }
.btn-primary-large { background: #111827; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; transition: transform 0.2s; }
.btn-primary-large:hover { transform: scale(1.05); }

/* BENEFITS */
.benefit-v { display: flex; flex-direction: column; align-items: center; gap: 0.75rem; }
.benefit-v i { font-size: 1.5rem; color: #f97316; }
.benefit-v span { font-weight: 800; font-size: 0.75rem; text-transform: uppercase; color: #4b5563; }

@media (max-width: 768px) {
  .tier-header, .tier-content { padding: 2rem 1.5rem; }
  .tier-price { font-size: 3rem; }
}
</style>